import { HeaderMode } from '../../table-header/enums/HeaderMode';
import { GridState, GridStateActions, GridEvent, GridNotification, NotificationData } from './grid-state.interface';

/**
 * Idle State - The default state when no operations are in progress
 */
export class IdleState implements GridState {
  getMode(): HeaderMode {
    return HeaderMode.Idle;
  }

  onEnter(actions: GridStateActions): void {
    actions.enableCheckboxColumn();
    actions.enableEditColumn();
    actions.disableInlineEditing();
    actions.refreshGrid();
  }

  onExit(actions: GridStateActions, event: GridEvent): void {
  }

  canTransitionTo(event: GridEvent): HeaderMode | null {
    switch (event) {
      case 'SELECT':
        return HeaderMode.Selection;
      case 'START_EDIT':
        return HeaderMode.Edit;
      case 'DUPLICATE':
        return HeaderMode.Duplication;
      default:
        return null;
    }
  }

  handleNotification(notification: GridNotification, data: NotificationData, actions: GridStateActions): GridEvent | null {
    switch (notification) {
      case 'ROW_SELECTION_CHANGED':
        // If rows are selected, transition to Selection
        if (data.selectedCount && data.selectedCount > 0) {
          return 'SELECT';
        }
        return null;

      case 'CELL_EDITED':
        // If a cell is edited, transition to Edit mode
        return 'START_EDIT';

      case 'EDIT_MODE_REQUESTED':
        // Activate the requested cell for editing
        if (data.row !== undefined && data.cell !== undefined) {
          actions.activateCell(data.row, data.cell);
        }
        return null;

      default:
        return null;
    }
  }

  getDataToSave(context: { duplicatedRows: any[]; editedRows: Map<number, any> }): any[] {
    return [];
  }
}
